(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-best-sellers')) {
  class JewelzitBestSellers extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.viewport = this.querySelector('[data-jz-bs-viewport]');
      this.track = this.querySelector('[data-jz-bs-track]');
      this.prev = this.querySelector('[data-jz-bs-prev]');
      this.next = this.querySelector('[data-jz-bs-next]');

      if (!this.viewport || !this.track) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });

      requestAnimationFrame(() => this.updateButtons());
    }

    scroll(direction) {
      const card = this.track.querySelector('.jz-bs__card');
      if (!card) return;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = card.getBoundingClientRect().width + gap;

      this.viewport.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const x = this.viewport.scrollLeft;
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;
    }
  }

  customElements.define('jz-best-sellers', JewelzitBestSellers);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["birthstone-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-birthstones')) {
  class JewelzitBirthstones extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.panels = Array.from(this.querySelectorAll('[data-jz-stone-panel]'));
      this.buttons = Array.from(this.querySelectorAll('[data-jz-stone]'));

      this.buttons.forEach((button) => {
        button.addEventListener('click', () => this.show(Number(button.dataset.jzStone)));
      });
    }

    show(index) {
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.buttons.forEach((button, i) => {
        const active = i === index;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('jz-birthstones', JewelzitBirthstones);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-announcement-v2')) {
  class JewelzitAnnouncementV2 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      if (this.dataset.closeMemory === 'true' && sessionStorage.getItem('jza2Closed') === '1') {
        this.hidden = true;
        return;
      }

      this.slides = Array.from(this.querySelectorAll('[data-jza2-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-jza2-dot]'));
      this.prev = this.querySelector('[data-jza2-prev]');
      this.next = this.querySelector('[data-jza2-next]');
      this.closeButton = this.querySelector('[data-jza2-close]');
      this.mode = this.dataset.mode || 'fade';
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.interval = Math.max(2000, Number(this.dataset.interval || 5000));
      this.index = 0;

      this.prev?.addEventListener('click', () => { this.show(this.index - 1); this.restart(); });
      this.next?.addEventListener('click', () => { this.show(this.index + 1); this.restart(); });
      this.dots.forEach((dot) => dot.addEventListener('click', () => {
        this.show(Number(dot.dataset.jza2Dot));
        this.restart();
      }));

      this.closeButton?.addEventListener('click', () => {
        this.hidden = true;
        this.stop();
        if (this.dataset.closeMemory === 'true') sessionStorage.setItem('jza2Closed', '1');
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      if (this.mode !== 'marquee') this.start();
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      this.index = (nextIndex + count) % count;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1 || this.mode === 'none') return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }
  }

  customElements.define('jz-announcement-v2', JewelzitAnnouncementV2);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-jewel-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-hero')) {
  class JewelzitHero extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = Array.from(this.querySelectorAll('[data-jz-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-jz-dot]'));
      this.index = 0;
      this.timer = null;
      this.pointerStart = null;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.querySelector('[data-jz-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
      this.querySelector('[data-jz-next]')?.addEventListener('click', () => this.go(this.index + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(Number(dot.dataset.jzDot), true));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.addEventListener('pointerdown', (event) => {
        this.pointerStart = event.clientX;
      });

      this.addEventListener('pointerup', (event) => {
        if (this.pointerStart === null) return;
        const distance = event.clientX - this.pointerStart;
        this.pointerStart = null;
        if (Math.abs(distance) < 50) return;
        this.go(this.index + (distance < 0 ? 1 : -1), true);
      });

      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    go(nextIndex, userInitiated) {
      if (this.slides.length < 2) return;
      const count = this.slides.length;
      this.index = (nextIndex + count) % count;

      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, index) => {
        const active = index === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (userInitiated) this.start();
    }

    start() {
      this.stop();
      if (this.slides.length < 2 || this.reducedMotion || this.dataset.autoplay !== 'true') return;
      const interval = Math.max(4000, Number(this.dataset.interval) || 6000);
      this.timer = window.setInterval(() => this.go(this.index + 1, false), interval);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  customElements.define('jz-hero', JewelzitHero);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelzit-announcement-static"]) return;
  try {
    
if (!customElements.get('jz-static-announcement')) {
  class JzStaticAnnouncement extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.animation = this.dataset.animation || 'fade';
      this.interval = Math.max(2000, Number(this.dataset.interval || 5000));

      this.querySelector('[data-prev]')?.addEventListener('click', () => { this.show(this.index - 1); this.restart(); });
      this.querySelector('[data-next]')?.addEventListener('click', () => { this.show(this.index + 1); this.restart(); });
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.show(i); this.restart(); }));

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
      }
      if (this.animation !== 'marquee') this.start();
    }

    show(next) {
      if (!this.slides.length) return;
      this.index = (next + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.index));
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1 || this.animation === 'none') return;
      this.stop();
      this.timer = setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    disconnectedCallback() { this.stop(); }
  }
  customElements.define('jz-static-announcement', JzStaticAnnouncement);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelzit-announcement-v2"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-announcement-v2')) {
  class JewelzitAnnouncementV2 extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      if (this.dataset.closeMemory === 'true' && sessionStorage.getItem('jza2Closed') === '1') {
        this.hidden = true;
        return;
      }

      this.slides = Array.from(this.querySelectorAll('[data-jza2-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-jza2-dot]'));
      this.prev = this.querySelector('[data-jza2-prev]');
      this.next = this.querySelector('[data-jza2-next]');
      this.closeButton = this.querySelector('[data-jza2-close]');
      this.mode = this.dataset.mode || 'fade';
      this.autoplay = this.dataset.autoplay === 'true';
      this.pauseOnHover = this.dataset.pauseHover === 'true';
      this.interval = Math.max(2000, Number(this.dataset.interval || 5000));
      this.index = 0;

      this.prev?.addEventListener('click', () => { this.show(this.index - 1); this.restart(); });
      this.next?.addEventListener('click', () => { this.show(this.index + 1); this.restart(); });
      this.dots.forEach((dot) => dot.addEventListener('click', () => {
        this.show(Number(dot.dataset.jza2Dot));
        this.restart();
      }));

      this.closeButton?.addEventListener('click', () => {
        this.hidden = true;
        this.stop();
        if (this.dataset.closeMemory === 'true') sessionStorage.setItem('jza2Closed', '1');
      });

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
      }

      if (this.mode !== 'marquee') this.start();
    }

    show(nextIndex) {
      if (!this.slides.length) return;
      const count = this.slides.length;
      this.index = (nextIndex + count) % count;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    start() {
      if (!this.autoplay || this.slides.length <= 1 || this.mode === 'none') return;
      this.stop();
      this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
    }

    stop() {
      if (this.timer) window.clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }
  }

  customElements.define('jz-announcement-v2', JewelzitAnnouncementV2);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jz-related-recent"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initSection(section) {
    if (!section || section.dataset.jzReady === 'true') return;
    section.dataset.jzReady = 'true';

    var storageKey = 'jewelzit_recently_viewed_v2';
    var currentDataEl = section.querySelector('[data-current-product]');
    var currentProduct = null;

    try {
      currentProduct = JSON.parse(currentDataEl ? currentDataEl.textContent : '{}');
    } catch (e) {}

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function discountPercent(item) {
      var compare = Number(item.comparePriceRaw || 0);
      var price = Number(item.priceRaw || 0);
      if (!compare || compare <= price) return 0;
      return Math.round(((compare - price) * 100) / compare);
    }

    function cardMarkup(item) {
      var discount = discountPercent(item);
      var showBadge = section.dataset.showBadge === 'true';
      var showCompare = section.dataset.showCompare === 'true';
      var showTitles = section.dataset.showTitles === 'true';
      var showQuickAdd = section.dataset.showQuickAdd === 'true';

      var badge = discount && showBadge
        ? '<span class="jz-rrv-card__badge">' + discount + '% OFF</span>'
        : '';

      var image = item.image
        ? '<img class="jz-rrv-card__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">'
        : '';

      var title = showTitles
        ? '<a class="jz-rrv-card__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>'
        : '';

      var compare = showCompare && discount
        ? '<s class="jz-rrv-card__compare">' + escapeHtml(item.comparePrice) + '</s>'
        : '';

      var quickAdd = showQuickAdd && item.available && item.variantId
        ? '<button class="jz-rrv-card__quick-add" type="button" data-quick-add="' + escapeHtml(item.variantId) + '" aria-label="Add ' + escapeHtml(item.title) + ' to cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 8h10l1 12H6L7 8Z"></path><path d="M9 9V7a3 3 0 0 1 6 0v2"></path><path d="M12 12v5M9.5 14.5h5"></path></svg></button>'
        : '';

      return '<article class="jz-rrv-card">' +
        '<a class="jz-rrv-card__media" href="' + escapeHtml(item.url) + '">' + badge + image + '</a>' +
        '<div class="jz-rrv-card__info">' + title +
          '<div class="jz-rrv-card__bottom">' +
            '<div class="jz-rrv-card__prices"><span class="jz-rrv-card__price">' + escapeHtml(item.price) + '</span>' + compare + '</div>' +
            quickAdd +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function saveCurrent() {
      if (!currentProduct || !currentProduct.id) return;
      try {
        var items = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(items)) items = [];
        items = items.filter(function(item) {
          return String(item.id) !== String(currentProduct.id);
        });
        items.unshift(currentProduct);
        localStorage.setItem(storageKey, JSON.stringify(items.slice(0, 24)));
      } catch (e) {}
    }

    function renderRecent() {
      var group = section.querySelector('[data-group="recent"]');
      var track = section.querySelector('[data-recent-track]');
      if (!group || !track) return;

      try {
        var items = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(items)) items = [];

        items = items.filter(function(item) {
          return String(item.id) !== String(currentProduct && currentProduct.id ? currentProduct.id : '');
        }).slice(0, Number(section.dataset.limit || 4));

        if (!items.length) {
          group.hidden = true;
          return;
        }

        group.hidden = false;
        track.innerHTML = items.map(cardMarkup).join('');
      } catch (e) {
        group.hidden = true;
      }
    }

    function initSliderControls() {
      section.querySelectorAll('[data-slider]').forEach(function(slider) {
        var track = slider.querySelector('[data-track]');
        var prev = slider.querySelector('[data-prev]');
        var next = slider.querySelector('[data-next]');
        if (!track) return;

        function amount() {
          var firstCard = track.querySelector('.jz-rrv-card');
          var gap = parseFloat(getComputedStyle(track).gap || '0');
          return (firstCard ? firstCard.getBoundingClientRect().width : 260) + gap;
        }

        if (prev) {
          prev.addEventListener('click', function() {
            track.scrollBy({ left: -amount(), behavior: 'smooth' });
          });
        }

        if (next) {
          next.addEventListener('click', function() {
            track.scrollBy({ left: amount(), behavior: 'smooth' });
          });
        }
      });
    }

    function loadRecommendations() {
      var target = section.querySelector('[data-recommendations-html]');
      var group = section.querySelector('[data-group="related"]');
      if (!target || !group) return;

      var base = section.dataset.recUrl;
      var productId = section.dataset.productId;
      var sectionId = section.dataset.sectionId;
      var limit = section.dataset.limit || '4';

      if (!base || !productId || !sectionId) return;

      var url = base + '?section_id=' + encodeURIComponent(sectionId) +
        '&product_id=' + encodeURIComponent(productId) +
        '&limit=' + encodeURIComponent(limit) +
        '&intent=related';

      fetch(url, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('Recommendations request failed');
          return response.text();
        })
        .then(function(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var replacement = doc.querySelector('#jz-rrv-' + CSS.escape(sectionId) + ' [data-recommendations-html]');

          if (replacement && replacement.children.length) {
            target.innerHTML = replacement.innerHTML;
          } else {
            group.hidden = true;
          }
        })
        .catch(function() {
          group.hidden = true;
        });
    }

    function quickAdd(button) {
      var variantId = Number(button.dataset.quickAdd);
      if (!variantId || button.disabled) return;

      button.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function(response) {
          if (!response.ok) throw new Error('Unable to add product');
          return response.json();
        })
        .then(function() {
          button.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
          window.setTimeout(function() {
            button.classList.remove('is-added');
          }, 1200);
        })
        .catch(function() {})
        .finally(function() {
          button.disabled = false;
        });
    }

    section.addEventListener('click', function(event) {
      var button = event.target.closest('[data-quick-add]');
      if (button) quickAdd(button);
    });

    saveCurrent();
    renderRecent();
    initSliderControls();
    loadRecommendations();
  }

  document.querySelectorAll('.jz-rrv').forEach(initSection);

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector ? event.target.querySelector('.jz-rrv') : null;
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["know-more-jewelzit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-story-slider')) {
  class JewelzitStorySlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.panels = Array.from(this.querySelectorAll('[data-jz-story-panel]'));
      this.dots = Array.from(this.querySelectorAll('[data-jz-story-dot]'));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.show(Number(dot.dataset.jzStoryDot)));
      });
    }

    show(index) {
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
  }

  customElements.define('jz-story-slider', JewelzitStorySlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arrivals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('jz-new-arrivals')) {
  class JewelzitNewArrivals extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.viewport = this.querySelector('[data-jz-na-viewport]');
      this.track = this.querySelector('[data-jz-na-track]');
      this.prev = this.querySelector('[data-jz-na-prev]');
      this.next = this.querySelector('[data-jz-na-next]');

      if (!this.viewport || !this.track) return;

      this.prev?.addEventListener('click', () => this.scroll(-1));
      this.next?.addEventListener('click', () => this.scroll(1));
      this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
      window.addEventListener('resize', () => this.updateButtons(), { passive: true });

      requestAnimationFrame(() => this.updateButtons());
    }

    scroll(direction) {
      const card = this.track.querySelector('.jz-na__card');
      if (!card) return;

      const styles = getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;
      const step = card.getBoundingClientRect().width + gap;

      this.viewport.scrollBy({
        left: direction * step,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const x = this.viewport.scrollLeft;
      if (this.prev) this.prev.disabled = x <= 2;
      if (this.next) this.next.disabled = x >= max - 2;
    }
  }

  customElements.define('jz-new-arrivals', JewelzitNewArrivals);
}

  } catch(e) { console.error(e); }
})();
})();
